import { RuleOperation } from '../enums/POR/RuleOperation';


export default class OnPremPortOpeningObject {
    id!: number;

	operation!: RuleOperation;

	creationDate!: Date;

	description!: string;

	isImplemented!: boolean;

	name!: string;

	azureName!: string;
	
	nestedObjects!: string;
	
	objectIPs!: string;
	
	objectURLsFQDNs!: string;
	
	previousVersion!: number;

	requestId!: number;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}